import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const dextTextAreaViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map